import NominalTransactionCriteriaModal from '../../components/modals/NominalTransactionCriteriaModal';
import { IDeprecatedWorkspaceAction, IWorkspaceAction } from '../../@types/workspaceTypes';
import React, { ReactElement, useState } from 'react';

enum NominalWorkspaceActions {
  AccountTransactionsReport = 'ACCOUNT_TRANSACTIONS_REPORT',
}

export const workspaceActionsForPermissions: Array<IDeprecatedWorkspaceAction> = [
  {
    actionReference: NominalWorkspaceActions.AccountTransactionsReport,
  },
];

export const useNominalWorkspaceActions = (): [actions: Array<IWorkspaceAction>, modals: ReactElement] => {
  const [nominalAccountTransactionsModalOpen, setNominalAccountTransactionsModalOpen] = useState(false);

  const actions: Array<IWorkspaceAction> = [
    {
      actionReference: NominalWorkspaceActions.AccountTransactionsReport,
      key: 'sales_daybook',
      text: 'Account Transactions Report',
      onClick: () => setNominalAccountTransactionsModalOpen(true),
    },
  ];

  return [
    actions,
    <NominalTransactionCriteriaModal
      isOpen={nominalAccountTransactionsModalOpen}
      onClose={() => setNominalAccountTransactionsModalOpen(false)}
    />,
  ];
};
